import type { Expression } from "mapbox-gl";

// Filter for showing dots when camera is zoomed out
export const POINT_FILTER_EXPRESSION: Expression = [">", 4, ["zoom"]];
// Filter for showing details when camera is zoomed in
export const DETAILS_FILTER_EXPRESSION: Expression = [">=", ["zoom"], 4];
// Fade out if is_timed_out
export const TIMED_OUT_EXPRESSION: Expression = ["case", ["has", "is_timed_out"], 0.5, 1];
